import { render, staticRenderFns } from "./TransferActionBtns.vue?vue&type=template&id=4689375a&scoped=true&"
import script from "./TransferActionBtns.vue?vue&type=script&lang=js&"
export * from "./TransferActionBtns.vue?vue&type=script&lang=js&"
import style0 from "./TransferActionBtns.vue?vue&type=style&index=0&id=4689375a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4689375a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
